import { Icon } from "semantic-ui-react";

import { useTranslation } from "react-i18next";

import { db } from "astrid-firebase";
import { useCollectionDataOnce } from "astrid-firestore/src/hooks/index";
import { languageNames } from "astrid-helpers/src/languages";

import useArticleTypeTranslations from "../../articles/hooks/useArticleTypeTranslations";

import displaySelectedCountries from "../utils/displaySelectedCountries";

export default function useDistributionPresetsTableColumns({ publisher }) {
	const { t } = useTranslation();

	const articleTypeTranslations = useArticleTypeTranslations();
	const [imprints] = useCollectionDataOnce(
		db.collection("imprints").where("publisher.id", "==", publisher.id).where("deleted", "==", false),
	);

	return [
		{
			id: "channel",
			Header: t("channel", "Channel"),
			accessor: ({ channel }) => channel?.name,
		},
		{
			id: "articleType",
			Header: t("articleType", "Article type"),
			accessor: ({ articleType }) => articleTypeTranslations[articleType],
		},
		{
			id: "languages",
			Header: t("languages", "Languages"),
			accessor: ({ languages }) => (languages.includes("all") ? t("all", "All") : languageNames(languages)),
		},
		{
			id: "imprintIds",
			Header: t("imprints", "Imprints"),
			accessor: ({ imprintIds }) => {
				return imprintIds
					?.map((id) => {
						return imprints?.find((imprint) => imprint.id === id)?.name;
					})
					.join(", ");
			},
		},
		{
			id: "targetData.countries",
			Header: t("countries", "Countries"),
			accessor: ({ targetData }) => {
				return displaySelectedCountries(targetData?.countries);
			},
		},
		{
			id: "targetData.prices",
			Header: t("prices", "Prices"),
			Cell: ({ value }) => {
				return value?.length > 0 && <Icon name="circle dollar" />;
			},
		},
		{
			id: "disabled",
			Header: t("enabled", "Enabled"),
			accessor: ({ disabled }) => {
				return disabled ? t("disabled", "Disabled") : t("enabled", "Enabled");
			},
		},
	];
}
